import React, { useEffect } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { Box, Container, Card } from "@material-ui/core";
import DraggableDialogComponent from './DraggableDialogComponent.jsx';
import redOverlap from './../assets/images/overlaps/overlap_red.png';
import redOverlapBottom from './../assets/images/overlaps/overlap_bottom_red.png';
import blueOverlap from './../assets/images/overlaps/overlap_blue.png';
import blueOverlapBottom from './../assets/images/overlaps/overlap_bottom_blue.png';
import yellowOverlap from './../assets/images/overlaps/overlap_yellow.png';
import yellowOverlapBottom from './../assets/images/overlaps/overlap_bottom_yellow.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Paper from "@material-ui/core/Paper";
const useStyles = makeStyles(() => ({

    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100%',
    },
    header: {
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        backgroundColor: 'rgb(239, 239, 239)',
        padding: '10px 0',
        marginTop: '15px',
    },
    contentCard: {
        margin: 0,
        padding: 0,
    },
    contentCardContainer: {
        height: '100%',
        overflowX: 'auto',
        overflowY: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        "& > *": {
            maxHeight: 'calc(100vh - 194px)',
        },
    },
    overlap: {
        top: '40px',
        left: 0,
        position: 'absolute',
        transform: "translate(-2%,-27%)",
        width: "100px",
        height: "62px",
        "& > img": {
            width: '100%',
            height: '100%',
            filter: 'drop-shadow(3px 0px 3px #555)',
            pointerEvents: "none",
        }
    },
    overlapBottom: {
        "& > img": {
            filter: 'none',
        }
    },
    overlapContent: {
        position: 'absolute',
        top: '31.5%',
        left: '92%',
        color: 'white',
        transform: "translate(-100%,-50%)",
        margin: 'auto',
    },
    overlapPadding: {
        marginLeft: '100px !important',
        fontStretch: 'extra-condensed',
    },
    submitButton: {
        background: "linear-gradient(0deg, rgba(0,122,82,1) 0%, rgba(0,159,145,1) 8%, rgba(0,94,71,1) 92%, rgba(0,135,122,1) 97%)",
        color: 'white',
        "& svg": {
            marginRight: '5px'
        },
    },
    cancelButton: {
        background: "linear-gradient(0deg, rgba(233,67,71,1) 0%, rgba(208,31,25,1) 99%)",
        color: 'white',
        "& svg": {
            marginRight: '5px'
        },
    },
    overlapContainerContent: {
        height: '100%',
        width: '100%',
        minWidth: '450px',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: "0px 0px 12px 3px #444",
    },
    dialogActions:{
        padding: '15px',
        background: ([userMode, variant]) => (variant === false) ? (userMode === true) ? '#CBE9FA' : '#FAD5CF' : '#f7d38b',
        borderTop: ([userMode, variant]) => (variant === false) ? (userMode === true) ? '3px solid #1CB3EA' : '3px solid #CA8283' : "3px solid #E2A327",
    },
    draggable: {
        cursor: 'move',
    },
    dialog: {
        background: 'none !important',
        boxShadow: 'none !important',
        maxWidth: '80vw',
        alignItems: "center",
        justifyContent: "center",
        overflowY: 'hidden !important',
        maxHeight: 'none !important'
    },

    form: {
        width: '100%', // Fix IE 11 issue.
        maxHeight: 'calc(100vh - 64px)',
    },
    ContainerStyle:{
        position: 'relative'
    }
}));

/*
preventOverSubmitClick - zapobiega przed kilkukrotnym wykonaniem funkcji akceptacji dialogu

W przypadku użycia onSubmit:

    const { ..., formState, reset } = useForm();
    ...
    preventOverSubmitClick = {formState: formState, reset: reset}

W przypadku użycia submitButton.onClick:

    preventOverSubmitClick={true}

*/

let preventOverSubmitClickState = false;
const OverlapDialog = (props) => {
    const { title, children, maxWidth, overlapContent, draggable, variant = false, open, submitButton, cancelButton, isLoading, onSubmit, handleDialogClose, onEntering, preventOverSubmitClick = {formState: {}, reset: () => {}} } = props;
    const userMode = sessionStorage.theme === "blue";
    const classes = useStyles([userMode, variant, maxWidth]);

    preventOverSubmitClick === true &&
		useEffect(() => {
			!isLoading && (preventOverSubmitClickState = false);
		}, [open]);

    return (
        <Dialog
            open={open}
            fullWidth={true}
            maxWidth={maxWidth}
            onClose={handleDialogClose}
            aria-labelledby="form-dialog-title"
            PaperComponent={draggable ? DraggableDialogComponent : Paper}
            PaperProps={{ classes: { root: classes.dialog } }}
            onEntering={onEntering}
        >
            <Container maxWidth={maxWidth} className={classes.ContainerStyle}>


                {variant === false &&
                    <>
                        <Box component='div' className={classes.overlap}>
                            <img src={userMode ? blueOverlap : redOverlap} alt="zakładka1" />
                            <Box component='div' className={classes.overlapContent}>
                                {overlapContent}
                            </Box>

                        </Box>
                        <Box component='div' className={classes.overlap + ` ` + classes.overlapBottom}>
                            <img src={userMode ? blueOverlapBottom : redOverlapBottom} alt="zakładka2" />
                        </Box>
                    </>
                }
                {variant === "yellow" &&
                    <>
                        <Box component='div' className={classes.overlap}>
                            <img src={yellowOverlap} alt="zakładka" />
                            <Box component='div' className={classes.overlapContent}>
                                {overlapContent}
                            </Box>

                        </Box>
                        <Box component='div' className={classes.overlap + ` ` + classes.overlapBottom}>
                            <img src={yellowOverlapBottom} alt="zakładka" />
                        </Box>
                    </>
                }


                {onSubmit && <form className={classes.form} noValidate onSubmit={(e) => {
                    onSubmit(e).then(() => {
						preventOverSubmitClick.reset && preventOverSubmitClick.reset(
							{},
							{
								keepErrors: true,
								keepSubmitCount: false,
							}
						);
					});
                }}>
                    <Card className={classes.overlapContainerContent}>

                        {title === undefined
                            ? ""
                            : <Box className={classes.header + ` ` + (draggable === true ? classes.draggable : '')} id="dialog-header">
                                <Typography className={classes.overlapPadding} component="h3" variant="h6" aria-label={"title"}>
                                    {title}
                                </Typography>
                            </Box>
                        }
                        <Box className={classes.contentCardContainer}>
                            <DialogContent dividers>
                                {children}
                            </DialogContent>

                        </Box>

                        {(submitButton || cancelButton) &&
                            <DialogActions className={classes.dialogActions}>
                                {submitButton &&
                                    <Button autoFocus variant={"contained"} type="submit" size={"small"} className={classes.submitButton} onClick={submitButton.onClick} disabled={submitButton.disabled || preventOverSubmitClick?.formState.submitCount > 0}>
                                        {isLoading && <CircularProgress color={"secondary"} size={16} />}
                                        {!isLoading && <FontAwesomeIcon icon={submitButton.icon} size="lg" />}
                                        {submitButton.content}
                                    </Button>
                                }
                                {cancelButton &&
                                    <Button variant={"contained"} size={"small"} className={classes.cancelButton} onClick={handleDialogClose}>
                                        {cancelButton.icon && <FontAwesomeIcon icon={cancelButton.icon} size="lg" />}
                                        {cancelButton.content}
                                    </Button>
                                }
                            </DialogActions>
                        }

                    </Card>
                </form>}
                {!onSubmit && <Card className={classes.overlapContainerContent}>

                        {title === undefined
                            ? ""
                            : <Box className={classes.header + ` ` + (draggable === true ? classes.draggable : '')} id="dialog-header">
                                <Typography className={classes.overlapPadding} component="h3" variant="h6" aria-label={"title"}>
                                    {title}
                                </Typography>
                            </Box>
                        }
                        <Box className={classes.contentCardContainer}>
                            <DialogContent className={classes.dialogContent} dividers>
                                {children}
                            </DialogContent>

                        </Box>

                        {(submitButton || cancelButton) &&
                            <DialogActions className={classes.dialogActions}>
                                {submitButton &&
                                    <Button autoFocus variant={"contained"} size={"small"} className={classes.submitButton} disabled={submitButton.disabled || preventOverSubmitClickState} onClick={(e) => {
                                            preventOverSubmitClick === true && (preventOverSubmitClickState = true);
                                            submitButton.onClick(e);
                                    }}>
                                        {isLoading && <CircularProgress color={"secondary"} size={16} />}
                                        {!isLoading && <FontAwesomeIcon icon={submitButton.icon} size="lg" />}
                                        {submitButton.content}
                                    </Button>
                                }
                                {cancelButton &&
                                    <Button variant={"contained"} size={"small"} className={classes.cancelButton} onClick={handleDialogClose}>
                                        {cancelButton.icon && <FontAwesomeIcon icon={cancelButton.icon} size="lg" />}
                                        {cancelButton.content}
                                    </Button>
                                }
                            </DialogActions>
                        }

                    </Card>}
            </Container>
        </Dialog>
    );
};



export default OverlapDialog;